import FormsRoutes from './FormsRoutes';

export default FormsRoutes;
